<template>
  <b-overlay :show="loading">
    <b-card
        title="جزئیات رژیم زیره پلاس"
    >
      <b-row align-h="center">
        <b-col
            lg="10"
            md="12"
        >
          <b-row>
            <b-col md="4">
              <b-form-group
                  label="نوع رژیم"
              >
                <v-select
                    v-model="form.DietType"
                    dir="rtl"
                    :reduce="x => x.value"
                    label="text"
                    input-id="DietType"
                    :clearable="false"
                    :options="filteredDietTypes"
                    class=""
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                  label="عنوان"
              >
                <b-form-input
                    id="Title"
                    v-model="form.Title"
                    autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                  label="متد رژیم"
              >
                <v-select
                    v-model="form.DietMethod"
                    dir="rtl"
                    :reduce="x => x.value"
                    label="text"
                    input-id="DietMethod"
                    :clearable="false"
                    :options="enums('DietMethod')"
                    class=""
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group style="margin-top: 35px">
                <b-form-checkbox
                    v-model="form.ShowSport2"
                    name="ShowSport2"
                    class="custom-control-primary"
                >
                  فعال سازی ورزش دوم
                </b-form-checkbox>
              </b-form-group>
            </b-col>
              <b-col md="3">
              <b-form-group style="margin-top: 35px">
                <b-form-checkbox
                    v-model="form.ActiveSpecialTips"
                    name="ShowSport2"
                    class="custom-control-primary"
                >
فعال سازی نکات اختصاصی
                </b-form-checkbox>
              </b-form-group>
            </b-col>
              <b-col md="3">
              <b-form-group style="margin-top: 35px">
                <b-form-checkbox
                    v-model="form.ActiveActivityTips"
                    name="ShowSport2"
                    class="custom-control-primary"
                >فعال سازی فعالیت ها</b-form-checkbox>
              </b-form-group>
            </b-col>


            <b-col md="12">
              <b-form-group
                  label="مکمل"
              >
                <dedicated-diet-supplement
                    v-model="form.SupplementIds"
                    :multiple="true"
                />
              </b-form-group>
            </b-col>


          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group
                  label="تعداد روز پیاده روی در هفته"
              >
                <b-form-input
                    id="SportDays"
                    v-model="form.SportDays"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="زمان پیاده روی در روز"
              >
                <b-form-input
                    id="SportMinute"
                    v-model="form.SportMinute"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="تعداد روز ورزش در هفته"
              >
                <b-form-input
                    id="SportCalorie"
                    v-model="form.SportCalorie"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                  label="آب"
              >
                <b-form-input
                    id="Water"
                    v-model="form.Water"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="چای"
              >
                <b-form-input
                    id="Tea"
                    v-model="form.Tea"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="قند"
              >
                <b-form-input
                    id="SugarLoaf"
                    v-model="form.SugarLoaf"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="شکر"
              >
                <b-form-input
                    id="Sugar"
                    v-model="form.Sugar"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group
                  label="توضیحات"
              >
                <b-form-textarea v-model="form.Description" rows="3" />
              </b-form-group>
            </b-col>

            <b-col cols="12" class="mt-2 mb-2">
              <span>بیماری ها</span>
              <div class="mt-1">
                <b-badge v-for="(sickness, index) in form.UserSickness" :key="index" v-text="sickness.Title" variant="light-danger" class="mr-1 mb-1" />
              </div>
            </b-col>

            <b-col cols="12">
              <b-form-group
                  label="توصیه"
              >
                <b-form-textarea v-model="form.Recommend" rows="8" />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-info"
                  class="mb-1"
                  @click="showModal"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                />
                <span>افزودن</span>
              </b-button>
            </b-col>

          </b-row>

          <b-card
              v-for="(meal,index) in form.UserSpecialDietFoodMeal"
              border-variant="dark"
              class="position-relative"
          >
            <b-row>
              <b-col md="3">
                <b-form-group
                    label="وعده"
                >
                  <z-food-meal
                      v-model="meal.FoodMealId"
                      :multiple="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="زمان صرف غذا"
                >
                  <b-form-input v-model="meal.EatTime" />
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group
                    label="ترتیب وعده"
                >
                  <b-form-input v-model="meal.Sort" type="number" />
                </b-form-group>
              </b-col>
              <b-button variant="danger" class="ml-auto h-25" @click="remove(meal.FoodMealId)"
              >
                <feather-icon
                    icon="TrashIcon"
                    size="16"
                    class="cursor-pointer"
                />
              </b-button>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="توضیحات"
                >
                  <b-form-textarea v-model="meal.Description" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-for="(item, userSpecialDietFoodMealListIndex) in meal.UserSpecialDietFoodMealList">
              <b-col md="12">
                <hr>
              </b-col>
              <b-col md="1">
                <b-form-group
                    label="ترتیب"
                >
                  <b-form-input v-model="item.Sort" type="number" />
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group
                    label="لیست غذایی"
                >
                  <dedicated-diet-list-food
                      v-model="item.SpecialDietFoodListId"
                      :multiple="false"
                      @selected="foods(item, $event)"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  v-for="food in item.UserSpecialDietFoodMealListRowDetails"
                  md="3"
              >
                <b-form-group
                    :label="`${getFoodAndFoodUntTitle(food.SpecialDietFoodListRowDetailsId)}`"
                >
                  <b-form-input v-if="showAmount(food.SpecialDietFoodListRowDetailsId)" v-model="food.Amount" />
                  <b-form-input v-else readonly :value="food.Description" />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                    label="توضیحات"
                >
                  <b-form-input v-model="item.Description" />
                </b-form-group>
              </b-col>
              <b-col md="10">
                <b-form-group>
                  <b-form-checkbox
                      v-model="item.OnlyOnceAtWeek"
                      name="OnlyOnceAtWeek"
                      value="true"
                      class="custom-control-success"
                  >
                    این لیست غذایی فقط یکبار در هفته استفاده شود.
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col
                  align-self="end"
                  class="text-right"
              >
                <trash
                    v-model="meal.UserSpecialDietFoodMealList"
                    :index="userSpecialDietFoodMealListIndex"
                    class="mb-1"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <feather-icon
                    class="btn-icon btn-outline-info cursor-pointer"
                    icon="PlusIcon"
                    size="24"
                    @click="meal.UserSpecialDietFoodMealList.push({
                    SpecialDietFoodListId: null,
                    Sort: 0,
                    UserSpecialDietFoodMealListRowDetails:[]})"
                />
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col class="text-right">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="submit"
              >
                ذخیره
              </b-button>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  @click="back"
              >
                بازگشت
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
        v-model="isShow"
        ok-title="افزودن"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="توصیه"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="addRecommend"
    >
      <b-col cols="12" class="mt-2 mb-2">
        <b-form-group
            label="توصیه"
            label-for="RecommendId"

        >
          <dedicated-diet-recommendations
              v-model="RecommendId"
              :multiple="false"
          />
        </b-form-group>
      </b-col>
    </b-modal>
  </b-overlay>
</template>

<script>

import ZFoodMeal from '@/tools/foodmeal.vue'
import DedicatedDietListFood from '@/tools/dedicatedDietListFood'
import {mapState} from "vuex";
import DedicatedDietSupplement from '@/tools/dedicatedDietSupplement'
import DedicatedDietRecommendations from '@/tools/dedicatedDietRecommendations'

export default {
  name: "UserSpecialDietDetails",
  components: {
    ZFoodMeal,
    DedicatedDietListFood,
    DedicatedDietSupplement,
    DedicatedDietRecommendations
  },
  data() {
    return {
      isShow: false,
      RecommendId: null,
      Recommend: [],
      form: {
        Id: null,
        Title: null,
        Description: null,
        UserSpecialDietRecommend: [],
        UserSpecialDietSupplement: [],
        UserSpecialDietFoodMeal: [],
        Recommend: null,
        DietMethod: null,
        DietType: null,
        ShowSport2: false,
        ActiveActivityTips: true,
        ActiveSpecialTips: true
      },
      loading: false,
    }},
  created() {
    if (this.$route.params.id) {
      this.form.Id = this.$route.params.id
      this.get()
    }

    this.$http.post(
        this.$api.recommend.getall, {},
    )
        .then(res => {
          res.data.forEach(item => {
             this.Recommend.push(item)
          })
        })
  },
  mounted() {
    document.addEventListener("keydown", this.saveCtrlS);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.saveCtrlS);
  },
  computed: {
    ...mapState('zirehState', { foodList: state => state.specialDietFoodListSelect }),
    getFoodAndFoodUntTitle() {
      return id => {
        let title = ''
        if (this.foodList && this.foodList.length) {
          const specialDietFoodListRowDetails = this.foodList.flatMap(x => x.SpecialDietFoodListRowDetails).filter(x => x.Id === id)[0]
          title = specialDietFoodListRowDetails.Food.Title

          if (specialDietFoodListRowDetails.FoodUnit){
            title += ' / ' + specialDietFoodListRowDetails.FoodUnit.Title
          }
        }

        return title
      }
    },
    diffStartDateDiet() {
      return this.$moment().diff(this.form.StartDate, 'days')
    },
    showConfirm() {
      return this.$moment(this.form.CreatedAt).format('YYYY-MM-DD') === this.$moment().format('YYYY-MM-DD')
    },
    showAmount() {
      return id => {
        if (this.foodList && this.foodList.length) {
          const specialDietFoodListRowDetails = this.foodList.flatMap(x => x.SpecialDietFoodListRowDetails).filter(x => x.Id === id)[0]
          return specialDietFoodListRowDetails.FoodUnit != null
        }
        return false
      }
    },
    filteredDietTypes(){
      // { key: 'FastingWithExpert', text: 'رژیم فستینگ با کارشناس', value: 2 },
      // { key: 'WithExpert', text: 'رژیم با کارشناس', value: 4 },
      // { key: 'SportDiet', text: 'رژیم ورزشی با کارشناس', value: 11 }

      return this.enums('DietType').filter(i => [2, 4, 11].includes(i.value))
    }
  },
  methods: {
    foods(item, listDiet) {
      item.UserSpecialDietFoodMealListRowDetails = []

      this.foodList.filter(x => x.Id === listDiet.Id)[0].SpecialDietFoodListRowDetails.forEach(food => {
        item.UserSpecialDietFoodMealListRowDetails.push({
          SpecialDietFoodListRowDetailsId: food.Id,
          Amount: null,
        })
      })
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.userspecialdiet.get, {
            Id: this.$route.params.id,
          },
      )
          .then(res => {
            this.loading = false
            this.form = res.data
          })
    },
    saveCtrlS(e){
      if (e.keyCode === 83 && e.ctrlKey) {
        e.preventDefault();

        this.submit()
      }
    },
    submit() {
      const callApi = (val)=>{
          this.form.ConfirmChangeExpiryDate = val
          let url = this.$api.userspecialdiet.update
          this.loading = true
          this.$http.post(url, this.form)
              .then(() => {
                  this.loading = false
              })
              .finally(() => { this.loading = false })
      }

      if (this.showConfirm) {
        this.$bvModal
            .msgBoxConfirm(`از زمان پرداخت کاربر تا الان ${this.diffStartDateDiet} روز گذشته است. آیا ${this.diffStartDateDiet} روز به تاریخ انقضا دوره کاربر اضافه شود ؟`, {
              size: 'sm',
              okVariant: 'primary',
              okTitle: 'ذخیره',
              cancelTitle: 'خیر',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
            })
            .then(val => {
                callApi(val)
            })
      }else callApi(false)
    },
    showModal(){
      this.RecommendId = null
      this.isShow = true
    },
    addRecommend() {
      if (this.form.Recommend) {
        this.form.Recommend += "\n" + this.Recommend.filter(x=> x.Id === this.RecommendId)[0].Description
      } else this.form.Recommend = this.Recommend.filter(x=> x.Id === this.RecommendId)[0].Description
    },
    remove(id) {
      this.$bvModal.msgBoxConfirm('آیا مطمئن هستید که می خواهید این وعده را حذف کنید؟', {
        title: 'حذف',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'تایید',
        cancelTitle: 'انصراف',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      }).then(confirm => {
        if (confirm) {
          this.$http.post('/userspecialdiet/meal/remove', {
            "UserSpecialDietIdId":   this.$route.params.id,
            "MealId": id
          }).then(() => {
            this.form.UserSpecialDietFoodMeal = this.form.UserSpecialDietFoodMeal.filter(x => x.FoodMealId !== id);
          })
        }
      })
    },
  },
}
</script>
